<template>
    <div :class="['card', 'border-2', mostPopularTariff ? 'border-primary' : 'border-light']">
        <div class="card-header">
            <h3 class="card-title font-weight-semibold">{{ tariff.name }}</h3>
        </div>
        <div class="card-body">

            <div class="d-flex align-items-center">
                <h3 class="mb-0 font-weight-bold">{{ formatNumber(tariff.price) }} грн</h3>
            </div>

            <div class="d-flex align-items-center text-muted">
                <span class="mb-0">{{ formatNumber(pricePerMonth) }} грн</span>
                <span class="text-muted ml-1"> / {{ $t('labels.month').toLowerCase() }}</span>

                <span v-if="totalSavings > 0" class="text-success-600 ml-2">{{ $t('labels.save').toLowerCase() }} {{ formatNumber(totalSavings) }} грн</span>
            </div>

            <ul class="pricing-table-list list-unstyled mt-3 mb-3">
                <li><i class="icon-checkmark3 text-success mr-3"></i><strong>{{ formatNumber(tariff.products_limit) }}</strong> {{ $t('labels.products') }}</li>
                <li><i class="icon-checkmark3 text-success mr-3"></i><strong>{{ formatNumber(tariff.integrations_limit) }}</strong> {{ $t('labels.integrations') }}</li>
            </ul>

            <button type="button" class="btn btn-primary legitRipple" @click="updateTariff" :disabled="disabled">{{ $t('buttons.pay') }}</button>
        </div>
        <div class="card-footer alpha-primary text-primary-800 d-flex justify-content-center align-items-center font-weight-semibold" v-if="mostPopularTariff">
            {{ $t('labels.most_popular') }}
        </div>
        <div class="card-footer bg-transparent border-top-0 pt-0" style="height: 51px;" v-else></div>
    </div>
</template>
<script>
import { httpClient } from '../../../../../services/HttpClient';

export default {
    name: 'TariffPlanCard',
    props: {
        mostPopularTariff: {
            type: Boolean,
            default: false
        },
        tariff: {
            type: Object,
            required: true
        },
        selectedPeriod: {
            type: String,
            default: 'month'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        baseTariff: {
            type: Object,
            default: null
        }
    },
    methods: {
        formatNumber(value) {
            if (value === null || value === undefined) return '';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        calculateMonthlyPrice(price, months) {
            return Math.round(price / months);
        },
        calculateTotalSavings(price, months) {
            if (!this.baseTariff) return 0;
            const expectedTotal = this.baseTariff.price * months;
            return Math.max(0, Math.round(expectedTotal - price));
        },
        updateTariff() {
            httpClient.post(`/projects/${this.$route.params.projectUuid}/core/tariffs/${this.tariff.uuid}/payments`).then((response) => {
                window.location.href = response.data.data.external_url;
            })
        }
    },
    computed: {
        pricePerMonth() {
            switch (this.selectedPeriod) {
                case '1':
                    return this.calculateMonthlyPrice(this.tariff.price, 1);
                case '3':
                    return this.calculateMonthlyPrice(this.tariff.price, 3);
                case '6':
                    return this.calculateMonthlyPrice(this.tariff.price, 6);
                case '12':
                    return this.calculateMonthlyPrice(this.tariff.price, 12);
                default:
                    return 0;
            }
        },
        totalSavings() {
            switch (this.selectedPeriod) {
                case '1':
                    return 0;
                case '3':
                    return this.calculateTotalSavings(this.tariff.price, 3);
                case '6':
                    return this.calculateTotalSavings(this.tariff.price, 6);
                case '12':
                    return this.calculateTotalSavings(this.tariff.price, 12);
                default:
                    return 0;
            }
        }
    }
}
</script>
